import { render, staticRenderFns } from "./Workorder.vue?vue&type=template&id=6f371600&scoped=true&"
import script from "./Workorder.vue?vue&type=script&lang=js&"
export * from "./Workorder.vue?vue&type=script&lang=js&"
import style0 from "./Workorder.vue?vue&type=style&index=0&id=6f371600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f371600",
  null
  
)

export default component.exports